<template>
  <div>
    <header class="main_header">
      <div class="left_div">
        <div class="logo logo_heading">
          <a href="/"><img src="https://www.sitepal.com/api/examples/images/logo.png" alt="SitePal"></a>
        </div>
      </div>
    </header>

    <table id="tblContainer" cellspacing="0" align="center" border="0">

      <tr>
        <td id="tdContent">
          <p class="feature_entire_heading text-center f-bold h2" align="center"><b>AI Agent with Speech Input - Using
              Vue JS</b></p>
          <p class="feature_entire_heading text-center" id="normal-text" align="center">In this example we demonstrate
            an AI Agent that responds to speech input. <br>Read our <a class="selected_support"
              href="/docs/Implementing_Your_AI_Agent.pdf" target="_blank">technical note</a> to learn more.</p>
          <p class="feature_entire_heading text-center" id="warning-text">Note: as we've detected this browser does not
            yet support the Web Speech API we've automatically replaced speech input with text input.</p>

          <!-- <p class="feature_entire_heading text-center" id="warning-text">Note: as we've detected this browser does not
            yet support the Web Speech API we've automatically replaced speech input with text input.</p> -->

          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <td align="center" COLSPAN="2" class="feature_entire_heading text-center sayAi">
              <!-- ******************************* SITEPAL EMBED CODE START  ***********************  -->
              <SitePal embed='16851,360,480,"",1,1, 2695840, 0,1,1,"5c6fde06460aa8ab405bf4f13cf93cf0",0' />
              <!-- ******************************* SITEPAL EMBED CODE END  ***********************  -->
              <br>

              <form NAME="myForm" class="form" @submit="sayAudio">
                <!-- <input name="textToSay" id="myInput" value="" class="form-control d-inline w-25">

                <input TYPE="button" id="myButton" VALUE="Ask AI Engine"
                  onClick="javascript:sayAI(textToSay.value, 1, 1, 3);" class="btn btn-primary"> -->
                <div class="p-3" id="p-3" style="border: 1px solid gray; height: 300px; border-radius: 8px;">
                  <span id="final" class="text-light"></span>
                  <span id="interim" class="text-secondary"></span>
                </div>
                <div class="mt-4" id="mt-4">
                  <button type="button" id="start" @click="startSpeechRecognition">Start Recognition</button>
                  <button type="button" id="stop" @click="stopSpeechRecognition">Stop Recognition</button>
                  <p id="status" class="lead mt-3 text-light" style="display: none">Listening ...</p>
                </div>

                <br><br>
              </form>
              <iframe ref="frameContent" id="simple-content" align="top" height="200" width="400"></iframe>
            </td>

            <tr align="middle">
              <td align="center" COLSPAN="2" class="feature_entire_heading text-center">
                <p>Real-time Artificial Intelligence Engine provides automatic Text and
                  Audio responses to the questions provided. </p>
                <p>The Audio is generated automatically via a Text To Speech engine according to the selected voice and
                  language.</P><br>
              </td>
            </tr>
          </table>
        </td>
      </tr>

    </table>
    <footer>
      <div class="footer-menu oddcast text-center">
        <ul class="w-50 m-auto ">
          <li class="w-100 f-bold ">Please feel free to use the source code of this page as an example.</li>
          <li>To view the source code of this page, <a href="/api/examples/vue-ai-speak/Sitepal-vue-speak-ai.zip"
              download="">download</a>
            souce code</li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
import SitePal from 'sitepal-vue'

export default {
  name: 'ThreeDCharacter',
  components: {
    SitePal
  },
  data() {
    return {
      speechRecognition: null,
      sppechStopCalled: 0,
      isMacSafari: 0,
      firstemptyAudioPlayed: 0,
      final_transcript: "",
      aiString: "",
      body: "",
      bodyText: "",
      htmlText: "",
      oldBodyText: "",
      textToSay: '',
      iframeContent: ''
    };
  },
  mounted() {
    window.vh_aiResponse = (aiString) => {
      if (!this.textToSay.trim()) {
        console.error('Input is empty');
        return;
      }

      let aiResponse = aiString;

      this.iframeContent = `<br><font color="#FF0000">Q - ${this.textToSay}</font><br><font color="#0000FF">A - ${aiResponse}</font>${this.iframeContent}`;

      // Update iframe content
      this.$refs.frameContent.contentDocument.open();
      this.$refs.frameContent.contentDocument.write(`<html><body bgcolor="#FFFFFF">${this.iframeContent}</body></html>`);
      this.$refs.frameContent.contentDocument.close();
      // Clear the input field
      this.textToSay = '';

      document.querySelector("#interim").innerHTML = "";
    };

    if (("webkitSpeechRecognition" in window || "SpeechRecognition" in window) && !this.isFacebookApp()) {
      this.initializeSpeechRecognition();
    } else {
      this.handleSpeechRecognitionNotAvailable();
    }

    window.vh_talkEnded = () => {
      this.startSpeechRecognition() // To start speech recognition if it is stopped while scene was answering
    }
  },
  methods: {

    initializeSpeechRecognition() {
      // Initialize speech recognition object
      this.speechRecognition = new (window.webkitSpeechRecognition || window.SpeechRecognition)();

      // Configure speech recognition properties
      this.speechRecognition.continuous = true;
      this.speechRecognition.interimResults = true;
      this.speechRecognition.maxAlternatives = 1;
      this.speechRecognition.lang = 'en-US'; // Adjust language as needed

      // Set event listeners
      this.speechRecognition.onstart = () => {
        console.log("Speech recognition started.");
        document.querySelector("#status").style.display = "block";
      };

      this.speechRecognition.onerror = (error) => {
        console.error("Speech recognition error:", error);
        document.querySelector("#status").style.display = "none";
      };

      this.speechRecognition.onend = () => {
        console.log("Speech recognition ended.");
        document.querySelector("#status").style.display = "none";
      };

      this.speechRecognition.onresult = (event) => {
        console.log("Speech recognition result.");
        this.handleSpeechRecognitionResult(event);
      };
    },

    handleSpeechRecognitionResult(event) {
      // Handle speech recognition results
      let interim_transcript = "";
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal && event.results[i][0].confidence > 0) {
          let transcript = event.results[i][0].transcript.trim();
          if (transcript !== "") {
            document.querySelector("#status").style.display = "none";
            this.speechRecognition.stop();
            this.final_transcript = "";
            this.interim_transcript = "";
            this.final_transcript += " " + transcript;
            this.textToSay = this.final_transcript;
            window.sayAI(this.final_transcript, 1, 1, 3);

          }
        } else {
          interim_transcript += event.results[i][0].transcript;
          document.querySelector("#final").innerHTML = "";
          document.querySelector("#interim").innerHTML = interim_transcript;
        }
      }
    },

    startSpeechRecognition() {
      if (this.isMacSafari === 1) {
        if (this.firstemptyAudioPlayed === 0) {
          window.saySilent(0);
        } else {
          this.sppechStopCalled = 0;
          this.speechRecognition.start();
        }
      } else {
        this.sppechStopCalled = 0;
        this.speechRecognition.start();
      }
    },

    stopSpeechRecognition() {
      this.sppechStopCalled = 1;
      this.speechRecognition.stop();
      document.querySelector("#final").innerHTML = "";
      document.querySelector("#interim").innerHTML = "";
      document.querySelector("#status").style.display = "none";
    },

    isFacebookApp() {
      // Implement your isFacebookApp function
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    },

    handleSpeechRecognitionNotAvailable() {
      console.log("Speech Recognition Not Available");
      // Adjust UI or handle logic when Speech Recognition is not available
    },

  },
};
</script>

<style scoped>
@import 'https://sitepal.com/api/examples/css/apiExample.css';

header {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding: .5rem 1rem;

  p {
    margin-left: 1rem;
  }
}

nav {
  margin-left: auto;

  ul {
    list-style: none;
  }

  ul li {
    display: inline-flex;
    margin-left: 1rem;
  }
}

.mt-4 button {
  border: 1px solid #CECECE;
  padding: 5px 15px;
  margin: 10px;
  border-radius: 5px;
  background: #CECECE;
  color: #000;
}

.p-3 {
  height: 40px !important;
  margin-bottom: 20px;
  background: #ececec;
  padding: 8px;
}

#warning-text {
  color: red;
  display: none;
}

form.form {
  float: left;
  width: 100%;
}
</style>